import { dao } from '@platform/dao';
import type { IGlobalModuleWrite, IPlatformCatalog } from '@platform/dao';
import { baseApi, run } from './baseApi';
import { refreshModuleCaches } from './refreshModuleCaches';

/**
 * Глобальний каталог «Налаштування › Глобально» (ADR-027): стан модулів для всіх робочих просторів, кількість записів у всіх просторах і
 * глобальні перевизначення типів. Глобальні назва й доступність модуля змінюють каталоги й меню кожного простору без власного стану —
 * після зміни перечитуються глобальний каталог, каталоги закешованих просторів і визначення модуля (refreshModuleCaches).
 */
export const platformCatalogApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    platformCatalog: b.query<IPlatformCatalog, void>({
      queryFn: () => run(() => dao.globals.catalog()),
      providesTags: ['GlobalCatalog'],
    }),
    updateGlobalModule: b.mutation<void, { key: string; body: IGlobalModuleWrite }>({
      queryFn: ({ key, body }) => run(() => dao.globals.updateModule(key, body)),
      async onQueryStarted({ key }, { dispatch, queryFulfilled }) {
        if (await queryFulfilled.then(() => true, () => false)) await dispatch(refreshModuleCaches(key));
      },
    }),
    resetGlobalModule: b.mutation<void, { key: string; recordType?: string }>({
      queryFn: ({ key, recordType }) => run(() => dao.globals.resetModule(key, recordType)),
      async onQueryStarted({ key }, { dispatch, queryFulfilled }) {
        if (!(await queryFulfilled.then(() => true, () => false))) return;
        dispatch(baseApi.util.invalidateTags(['GlobalOverride']));
        await dispatch(refreshModuleCaches(key));
      },
    }),
  }),
});

export const { usePlatformCatalogQuery, useUpdateGlobalModuleMutation, useResetGlobalModuleMutation } = platformCatalogApi;
